import styled from 'styled-components';

export const VenueNamePopOverStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 16px;
  background-color: ${props => props.theme.uiColors.multiFlightMapBackgroundColor};
  border-radius: 8px;
  .venueNamePopOver {
    &__input.customInput {
      width: 100%;
    }

    &__buttonsContainer {
      display: inline-flex;
      gap: 4px;
    }

    &__acceptButton {
      width: 169px;
    }
  }
`;
